import React from "react";
import themePropTypes from "../theme-prop-types";
import Text from "./text";

const Consenter = ({ firstName, lastName, phone_number }) => (
  <>
    <Text
      label={
        <b>
          {firstName} {lastName}
        </b>
      }
    />
    <Text label={phone_number} />
  </>
);

Consenter.propTypes = themePropTypes.consenter;

export default Consenter;
